import React, { memo, ChangeEvent } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { VOLUME_TYPE_OPTIONS } from 'apps/rms/constants/shipperRates'
import { IShipperRate, VOLUME_TYPE } from 'apps/rms/types/shipperRates'
import { TextInput } from 'components/atoms'

interface IVolumeProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
  volumeError?: string
  volumeTypeError?: string
  disabled?: boolean
}

export const Volume = memo<IVolumeProps>(
  ({ disabled, onChange, value: { volume, volumeType }, volumeError, volumeTypeError }) => {
    const volumeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      onChange({ volume: value })
    }

    const volumeTypeHandler = (e: ISelectOption<VOLUME_TYPE>) => {
      onChange({ volumeType: e.value })
    }

    return (
      <>
        <div className='col-md-4 col-xs-4'>
          <TextInput
            label='Volume'
            placeholder='Enter volume'
            value={volume || ''}
            onChange={volumeHandler}
            type='number'
            id='shipper-rates-volume'
            dataTest='modal-volume'
            validationMessage={volumeError}
            invalid={!!volumeError}
            disabled={disabled}
          />
        </div>
        <div className='col-md-4 col-xs-4'>
          <Select
            label='Volume Type'
            options={VOLUME_TYPE_OPTIONS}
            value={volumeType}
            onChange={volumeTypeHandler}
            id='shipper-rates-volume-type'
            dataTest='modal-volume-type'
            validationMessage={volumeTypeError}
            invalid={!!volumeTypeError}
            disabled={disabled}
          />
        </div>
      </>
    )
  }
)
